var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2037 18.3468L19.6637 18.0568C19.0537 17.9868 18.4537 18.1968 18.0237 18.6268L16.1837 20.4668C13.3537 19.0268 11.0337 16.7168 9.59367 13.8768L11.4437 12.0268C11.8737 11.5968 12.0837 10.9968 12.0137 10.3868L11.7237 7.8668C11.6037 6.8568 10.7537 6.0968 9.73367 6.0968H8.00367C6.87367 6.0968 5.93367 7.0368 6.00367 8.1668C6.53367 16.7068 13.3637 23.5268 21.8937 24.0568C23.0237 24.1268 23.9637 23.1868 23.9637 22.0568V20.3268C23.9737 19.3168 23.2137 18.4668 22.2037 18.3468Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalPhone);
export default __webpack_public_path__ + "static/media/local_phone.34721ad8303d53dc865686477ada5b00.svg";
export { ForwardRef as ReactComponent };